'use strict';

/**
 * This directive only renders a temp element so that ui-scroll has something
 * it can work with. Only if the element lives a while it actually renders
 * the directive. This gets done because rendering complicated directives
 * which never get displayed takes a lot of time and makes the scroll-list
 * very slow. By only having placeholders it renders over 10x faster.
 */
angular.module('mobile-apps')
	.directive('displayTempElement', ['$timeout', '$rootScope', '$compile', function($timeout, $rootScope, $compile) {
		return {
			link: function (scope, elem, attrs) {
				// Get the child content of the directive and save it for later
				var childContent = elem.html();

				// Calculate how high the placeholder element should be
				var height = 32;
				if (scope.entryData.draft && scope.entryData.value) {
					height = 89;
				} else if (scope.entryData._tags && scope.entryData._tags.length) {
					height = 46;
				}


				var loadingDisplayText = ''
				if (attrs.loadingDisplayKey) {
					loadingDisplayText = '<div class="placeholder-wrapper"><i class="fa fa-circle-o-notch fa-spin loading-icon" aria-hidden="true"></i> <div class="elipsis list-group-item-text vAlign idLabel temp-element-id" ng-class="list-group-item-text vAlign idLabel" title="hub_registration"><div class="idTag">ID</div><div class="idText">' + attrs.loadingDisplayKey + '</div></div></div>';
				} else {
					loadingDisplayText = 'Loading ...'
				}

				// Replace it with a placeholder
				elem.html('<div style="height: ' + height + 'px;">' + loadingDisplayText + '</div>');

				// Before we render it we wait to see if the element lives long
				// enough to be worth to be displayed
				var cancelTimeout = $timeout(function() {
					// Build the new element by getting the name of the directive
					// and setting it so that it can get rendered correctly
					var newElement = $(childContent);
					var directiveName = newElement.attr('display-directive');
					newElement.removeAttr('display-directive');
					newElement.attr(directiveName, '');

					var compiledHtml = $compile(newElement[0].outerHTML)(scope);
					$timeout(function(){
						// Compile the html so that the directive gets rendered and
						// so displayed correctly
						elem.html(compiledHtml);
					}, 50);
				}, 250);


				// If the element gets destroyed we cancel the render timeout and
				// are happy that we did not invest all the time in rendering
				// something that never got dispalyed.
				elem.on('$destroy', function() {
					if (cancelTimeout) {
						$timeout.cancel(cancelTimeout);
					}
				});

			}
		};
	}]);
